import './styles.css';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Avatar = ({ id = 3, peel = '#FFCA68' }) => {
  switch (id) {
    case 0:
      return (
        <svg viewBox="0 -3 264 280" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_1_2" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse">
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_1_2)">
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="#D0C6AC"
            />
            <path d="M296 36H32V316H296V36Z" fill="#EDB98A" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M188 115V138C188 168.928 162.928 194 132 194C101.072 194 76 168.928 76 138V115V130C76 160.928 101.072 186 132 186C162.928 186 188 160.928 188 130V115Z"
              fill="black"
              fillOpacity="0.1"
            />
          </g>
          <mask
            id="mask1_1_2"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="183"
            width="200"
            height="97"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M108 183.071C90.0813 185.076 76.2798 190.552 76.0042 204.645C50.1464 215.568 32 241.165 32 270.999V280H232V270.999C232 241.165 213.854 215.568 187.996 204.645C187.72 190.552 173.919 185.076 156 183.071V202C156 215.255 145.255 226 132 226C118.745 226 108 215.255 108 202V183.071Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_1_2)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M108 183.071C90.0813 185.076 76.2798 190.552 76.0042 204.645C50.1464 215.568 32 241.165 32 270.999V280H232V270.999C232 241.165 213.854 215.568 187.996 204.645C187.72 190.552 173.919 185.076 156 183.071V202C156 215.255 145.255 226 132 226C118.745 226 108 215.255 108 202V183.071Z"
              fill="#B7C1DB"
            />
            <path d="M264 170H0V280H264V170Z" fill="#3C4F5C" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M102 231.739V280H95V228.15C97.2038 229.46 99.5468 230.661 102 231.739ZM169 228.15V268.5C169 270.433 167.433 272 165.5 272C163.567 272 162 270.433 162 268.5V231.739C164.453 230.661 166.796 229.46 169 228.15Z"
              fill="#F4F4F4"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M90.9601 182.724C75.9093 185.571 65.5 191.243 65.5 202.308C65.5 222.02 98.5377 238 132 238C165.462 238 198.5 222.02 198.5 202.308C198.5 191.243 188.091 185.571 173.04 182.724C182.125 186.074 188 191.706 188 201.077C188 221.469 160.179 238 132 238C103.821 238 76 221.469 76 201.077C76 191.706 81.8751 186.074 90.9601 182.724Z"
              fill="black"
              fillOpacity="0.16"
            />
          </g>
          <path
            d="M141 152H123C121.343 152 120 153.343 120 155C120 156.657 121.343 158 123 158H141C142.657 158 144 156.657 144 155C144 153.343 142.657 152 141 152Z"
            fill="black"
            fillOpacity="0.7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M120 130C120 134.418 125.373 138 132 138C138.627 138 144 134.418 144 130"
            fill="black"
            fillOpacity="0.16"
          />
          <path
            d="M106 126C113.732 126 120 119.732 120 112C120 104.268 113.732 98 106 98C98.268 98 92 104.268 92 112C92 119.732 98.268 126 106 126Z"
            fill="white"
          />
          <path
            d="M158 126C165.732 126 172 119.732 172 112C172 104.268 165.732 98 158 98C150.268 98 144 104.268 144 112C144 119.732 150.268 126 158 126Z"
            fill="white"
          />
          <path
            d="M106 118C109.314 118 112 115.314 112 112C112 108.686 109.314 106 106 106C102.686 106 100 108.686 100 112C100 115.314 102.686 118 106 118Z"
            fill="black"
            fillOpacity="0.7"
          />
          <path
            d="M158 118C161.314 118 164 115.314 164 112C164 108.686 161.314 106 158 106C154.686 106 152 108.686 152 112C152 115.314 154.686 118 158 118Z"
            fill="black"
            fillOpacity="0.7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M114.66 93.0903C109.662 93.4522 104.737 93.1757 99.7423 92.9684C95.9124 92.8098 92.0249 92.2868 88.3685 93.9801C87.6683 94.304 83.8383 96.2592 83.9274 97.3289C83.9984 98.1844 87.863 99.5204 88.5587 99.765C92.2274 101.055 95.7394 100.661 99.5125 100.434C104.14 100.157 108.748 100.361 113.374 100.221C116.489 100.128 121.29 99.6003 122.83 95.8233C123.294 94.6857 122.935 92.4099 122.47 91.1658C122.285 90.6702 121.75 90.4835 121.345 90.7691C119.895 91.7921 117.084 92.9151 114.66 93.0903Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M149.341 93.0903C154.338 93.4522 159.263 93.1757 164.258 92.9684C168.088 92.8098 171.975 92.2868 175.632 93.9801C176.332 94.304 180.162 96.2592 180.073 97.3289C180.002 98.1844 176.137 99.5204 175.441 99.765C171.773 101.055 168.261 100.661 164.488 100.434C159.86 100.157 155.253 100.361 150.627 100.221C147.511 100.128 142.71 99.6003 141.17 95.8233C140.707 94.6857 141.065 92.4099 141.53 91.1658C141.715 90.6702 142.25 90.4835 142.655 90.7691C144.105 91.7921 146.916 92.9151 149.341 93.0903Z"
            fill="black"
            fillOpacity="0.6"
          />
          <mask
            id="mask2_1_2"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="264"
            height="280"
          >
            <path d="M264 0H0V280H264V0Z" fill="white" />
          </mask>
          <g mask="url(#mask2_1_2)">
            <mask
              id="mask3_1_2"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="72"
              y="98"
              width="121"
              height="120"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M113.18 149.737C115.363 148.105 128.407 147.479 130.758 146.089C131.492 145.655 132.061 145.216 132.5 144.78C132.939 145.216 133.509 145.655 134.242 146.089C136.593 147.479 149.637 148.105 151.82 149.737C154.03 151.391 155.644 155.185 155.467 158.151C155.255 161.71 151.361 170.203 141.672 171.181C139.558 168.828 136.237 167.31 132.5 167.31C128.763 167.31 125.442 168.828 123.328 171.181C113.639 170.203 109.745 161.71 109.533 158.151C109.357 155.185 110.97 151.391 113.18 149.737ZM151.142 166.906C151.143 166.906 151.145 166.905 151.146 166.905C151.144 166.905 151.143 166.906 151.142 166.906ZM113.845 166.901C113.849 166.903 113.857 166.906 113.862 166.908C113.857 166.906 113.851 166.903 113.845 166.901ZM192.863 127.985C192.474 122.03 191.278 116.152 190.234 110.286C189.953 108.707 188.424 98 187.735 98C187.502 107.109 186.702 116.08 185.67 125.139C185.361 127.848 185.038 130.556 184.825 133.274C184.654 135.47 184.96 138.122 184.428 140.246C183.749 142.952 180.348 145.478 177.703 146.411C171.103 148.737 165.598 139.108 159.961 136.291C152.643 132.635 140.064 131.764 132.582 136.53C124.936 131.764 112.357 132.635 105.039 136.291C99.4024 139.108 93.897 148.737 87.2972 146.411C84.6521 145.478 81.2504 142.952 80.5724 140.246C80.0403 138.122 80.3463 135.47 80.175 133.274C79.9624 130.556 79.6389 127.848 79.3302 125.139C78.2983 116.08 77.4975 107.109 77.2654 98C76.5762 98 75.0468 108.707 74.7659 110.286C73.7221 116.152 72.5258 122.03 72.1376 127.985C71.7385 134.105 72.2149 140.167 73.4696 146.163C74.0687 149.028 74.7685 151.876 75.5189 154.704C76.3527 157.847 75.199 163.966 75.5723 167.192C76.2788 173.296 79.1543 185.2 82.3833 190.451C83.9441 192.989 85.7735 194.574 87.8165 196.619C89.7826 198.588 90.6039 201.64 92.7261 203.737C96.682 207.645 102.446 209.971 108.366 210.543C113.677 215.05 122.506 218 132.5 218C142.495 218 151.323 215.05 156.635 210.543C162.554 209.971 168.318 207.645 172.274 203.737C174.396 201.64 175.217 198.588 177.184 196.619C179.226 194.574 181.056 192.989 182.617 190.451C185.846 185.2 188.721 173.296 189.428 167.192C189.801 163.966 188.647 157.847 189.481 154.704C190.232 151.876 190.931 149.028 191.531 146.163C192.785 140.167 193.261 134.105 192.863 127.985Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask3_1_2)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M113.18 149.737C115.363 148.105 128.407 147.479 130.758 146.089C131.492 145.655 132.061 145.216 132.5 144.78C132.939 145.216 133.509 145.655 134.242 146.089C136.593 147.479 149.637 148.105 151.82 149.737C154.03 151.391 155.644 155.185 155.467 158.151C155.255 161.71 151.361 170.203 141.672 171.181C139.558 168.828 136.237 167.31 132.5 167.31C128.763 167.31 125.442 168.828 123.328 171.181C113.639 170.203 109.745 161.71 109.533 158.151C109.357 155.185 110.97 151.391 113.18 149.737ZM151.142 166.906C151.143 166.906 151.145 166.905 151.146 166.905C151.144 166.905 151.143 166.906 151.142 166.906ZM113.845 166.901C113.849 166.903 113.857 166.906 113.862 166.908C113.857 166.906 113.851 166.903 113.845 166.901ZM192.863 127.985C192.474 122.03 191.278 116.152 190.234 110.286C189.953 108.707 188.424 98 187.735 98C187.502 107.109 186.702 116.08 185.67 125.139C185.361 127.848 185.038 130.556 184.825 133.274C184.654 135.47 184.96 138.122 184.428 140.246C183.749 142.952 180.348 145.478 177.703 146.411C171.103 148.737 165.598 139.108 159.961 136.291C152.643 132.635 140.064 131.764 132.582 136.53C124.936 131.764 112.357 132.635 105.039 136.291C99.4024 139.108 93.897 148.737 87.2972 146.411C84.6521 145.478 81.2504 142.952 80.5724 140.246C80.0403 138.122 80.3463 135.47 80.175 133.274C79.9624 130.556 79.6389 127.848 79.3302 125.139C78.2983 116.08 77.4975 107.109 77.2654 98C76.5762 98 75.0468 108.707 74.7659 110.286C73.7221 116.152 72.5258 122.03 72.1376 127.985C71.7385 134.105 72.2149 140.167 73.4696 146.163C74.0687 149.028 74.7685 151.876 75.5189 154.704C76.3527 157.847 75.199 163.966 75.5723 167.192C76.2788 173.296 79.1543 185.2 82.3833 190.451C83.9441 192.989 85.7735 194.574 87.8165 196.619C89.7826 198.588 90.6039 201.64 92.7261 203.737C96.682 207.645 102.446 209.971 108.366 210.543C113.677 215.05 122.506 218 132.5 218C142.495 218 151.323 215.05 156.635 210.543C162.554 209.971 168.318 207.645 172.274 203.737C174.396 201.64 175.217 198.588 177.184 196.619C179.226 194.574 181.056 192.989 182.617 190.451C185.846 185.2 188.721 173.296 189.428 167.192C189.801 163.966 188.647 157.847 189.481 154.704C190.232 151.876 190.931 149.028 191.531 146.163C192.785 140.167 193.261 134.105 192.863 127.985Z"
                fill="#5E7AA9"
              />
              <path d="M280 72H16V316H280V72Z" fill="#A55728" />
            </g>
            <mask
              id="mask4_1_2"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="73"
              y="26"
              width="118"
              height="73"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M166.309 35.0061C146.121 23.3065 126.129 25.222 111.037 29.03C95.9448 32.838 87.0168 43.6513 79.3567 59.6481C75.5956 67.5029 73.366 76.7915 73.0231 85.4814C72.8884 88.8933 73.3484 92.4152 74.2677 95.7004C74.6049 96.9062 76.4232 101.087 76.9225 97.7088C77.0885 96.5843 76.4804 95.0328 76.4216 93.8376C76.3444 92.2694 76.4273 90.6808 76.5342 89.1149C76.7341 86.1874 77.256 83.3154 78.1847 80.5247C79.5119 76.5367 81.2014 72.2129 83.7874 68.8481C90.1884 60.5206 101.269 60.0459 110.066 55.4636C109.303 56.8687 106.36 59.1433 107.379 60.7269C108.084 61.8207 110.749 61.4891 112.022 61.454C115.371 61.3624 118.735 60.7797 122.043 60.307C127.256 59.5618 132.141 58.0518 137.047 56.2181C141.063 54.7164 145.65 53.3257 148.669 50.1405C153.54 55.1881 159.81 59.9346 166.07 63.1429C171.688 66.0222 180.749 67.4611 184.183 73.3007C188.248 80.2148 186.378 88.7074 187.619 96.2008C188.091 99.0504 189.164 98.9866 189.751 96.4378C190.748 92.1083 191.219 87.6102 190.902 83.1593C190.184 73.1115 186.497 46.7057 166.309 35.0061Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask4_1_2)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M166.309 35.0061C146.121 23.3065 126.129 25.222 111.037 29.03C95.9448 32.838 87.0168 43.6513 79.3567 59.6481C75.5956 67.5029 73.366 76.7915 73.0231 85.4814C72.8884 88.8933 73.3484 92.4152 74.2677 95.7004C74.6049 96.9062 76.4232 101.087 76.9225 97.7088C77.0885 96.5843 76.4804 95.0328 76.4216 93.8376C76.3444 92.2694 76.4273 90.6808 76.5342 89.1149C76.7341 86.1874 77.256 83.3154 78.1847 80.5247C79.5119 76.5367 81.2014 72.2129 83.7874 68.8481C90.1884 60.5206 101.269 60.0459 110.066 55.4636C109.303 56.8687 106.36 59.1433 107.379 60.7269C108.084 61.8207 110.749 61.4891 112.022 61.454C115.371 61.3624 118.735 60.7797 122.043 60.307C127.256 59.5618 132.141 58.0518 137.047 56.2181C141.063 54.7164 145.65 53.3257 148.669 50.1405C153.54 55.1881 159.81 59.9346 166.07 63.1429C171.688 66.0222 180.749 67.4611 184.183 73.3007C188.248 80.2148 186.378 88.7074 187.619 96.2008C188.091 99.0504 189.164 98.9866 189.751 96.4378C190.748 92.1083 191.219 87.6102 190.902 83.1593C190.184 73.1115 186.497 46.7057 166.309 35.0061Z"
                fill="#28354B"
              />
              <path d="M263 0H-1V280H263V0Z" fill="#724133" />
            </g>
          </g>
        </svg>
      );
    case 1:
      return (
        <svg viewBox="0 -3 264 280" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_1_54"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="36"
            width="200"
            height="244"
          >
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_1_54)">
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="#D0C6AC"
            />
            <path d="M296 36H32V316H296V36Z" fill="#D08B5B" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M188 115V138C188 168.928 162.928 194 132 194C101.072 194 76 168.928 76 138V115V130C76 160.928 101.072 186 132 186C162.928 186 188 160.928 188 130V115Z"
              fill="black"
              fillOpacity="0.1"
            />
          </g>
          <mask
            id="mask1_1_54"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="199"
            width="200"
            height="81"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M171.32 199.936C205.706 205.367 232 235.139 232 271.052V280H32V271.052C32 235.138 58.2944 205.366 92.6818 199.936C93.5836 205.005 96.1164 209.824 100.236 213.539L129.321 239.768C130.843 241.14 133.157 241.14 134.679 239.768L163.764 213.539C164.189 213.155 164.601 212.756 164.998 212.343C168.414 208.787 170.517 204.452 171.32 199.936V199.936Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_1_54)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M171.32 199.936C205.706 205.367 232 235.139 232 271.052V280H32V271.052C32 235.138 58.2944 205.366 92.6818 199.936C93.5836 205.005 96.1164 209.824 100.236 213.539L129.321 239.768C130.843 241.14 133.157 241.14 134.679 239.768L163.764 213.539C164.189 213.155 164.601 212.756 164.998 212.343C168.414 208.787 170.517 204.452 171.32 199.936V199.936Z"
              fill="#E6E6E6"
            />
            <path d="M264 170H0V280H264V170Z" fill="#FFAFB9" />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M118 149C118 156.732 124.268 163 132 163C139.732 163 146 156.732 146 149"
            fill="black"
            fillOpacity="0.7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M120 130C120 134.418 125.373 138 132 138C138.627 138 144 134.418 144 130"
            fill="black"
            fillOpacity="0.16"
          />
          <mask
            id="mask2_1_54"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="92"
            y="103"
            width="28"
            height="16"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M106 117.048C115.61 117.048 120 121.499 120 114.562C120 107.624 113.732 103 106 103C98.268 103 92 107.624 92 114.562C92 121.499 96.39 117.048 106 117.048Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_1_54)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M106 117.048C115.61 117.048 120 121.499 120 114.562C120 107.624 113.732 103 106 103C98.268 103 92 107.624 92 114.562C92 121.499 96.39 117.048 106 117.048Z"
              fill="white"
            />
            <path
              d="M106 119C109.314 119 112 116.314 112 113C112 109.686 109.314 107 106 107C102.686 107 100 109.686 100 113C100 116.314 102.686 119 106 119Z"
              fill="black"
              fillOpacity="0.7"
            />
          </g>
          <mask
            id="mask3_1_54"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="144"
            y="103"
            width="28"
            height="16"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M158 117.048C167.61 117.048 172 121.499 172 114.562C172 107.624 165.732 103 158 103C150.268 103 144 107.624 144 114.562C144 121.499 148.39 117.048 158 117.048Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask3_1_54)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M158 117.048C167.61 117.048 172 121.499 172 114.562C172 107.624 165.732 103 158 103C150.268 103 144 107.624 144 114.562C144 121.499 148.39 117.048 158 117.048Z"
              fill="white"
            />
            <path
              d="M158 119C161.314 119 164 116.314 164 113C164 109.686 161.314 107 158 107C154.686 107 152 109.686 152 113C152 116.314 154.686 119 158 119Z"
              fill="black"
              fillOpacity="0.7"
            />
          </g>
          <path
            d="M91.5914 96.162C96.0875 89.8356 105.603 86.6535 115.347 89.7958C116.399 90.1348 117.526 89.5574 117.865 88.5061C118.204 87.4548 117.626 86.3278 116.575 85.9888C105.167 82.3099 93.8358 86.0989 88.3309 93.8448C87.6911 94.7452 87.9023 95.9938 88.8026 96.6336C89.703 97.2735 90.9516 97.0623 91.5914 96.162Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            d="M172.377 103.158C168.463 97.6491 157.73 94.5601 148.485 96.8304C147.412 97.0938 146.329 96.4378 146.065 95.3651C145.802 94.2924 146.458 93.2092 147.531 92.9458C158.267 90.3092 170.696 93.8862 175.638 100.841C176.278 101.741 176.067 102.99 175.166 103.629C174.266 104.269 173.017 104.058 172.377 103.158Z"
            fill="black"
            fillOpacity="0.6"
          />
          <mask
            id="mask4_1_54"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="264"
            height="280"
          >
            <path d="M264 0H0V280H264V0Z" fill="white" />
          </mask>
          <g mask="url(#mask4_1_54)">
            <mask
              id="mask5_1_54"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="49"
              y="18"
              width="157"
              height="172"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M58 102.34C58 118.921 58 145.474 58 182C58 186.418 61.5817 190 66 190H108V180.611C90.4692 172.283 77.9518 155.115 76.2086 134.867C70.4309 134.002 66 129.019 66 123V110C66 106.509 67.4904 103.367 69.8695 101.174C81.4088 98.5553 93.9707 93.6376 106.342 86.4953C118.473 79.4911 128.844 71.2579 136.821 62.7522C133.394 70.6604 129.245 77.588 124.372 83.535C137.047 78.0121 145.678 69.1324 150.264 56.8961C150.641 57.818 151.035 58.7389 151.444 59.6582C161.7 82.6926 179.318 99.0186 197.206 104.403C197.719 106.513 198 108.484 198 110V123C198 129.019 193.569 134.002 187.791 134.867C186.048 155.115 173.531 172.283 156 180.611V190H174C191.673 190 206 175.673 206 158C206 133.944 206 115.903 206 103.875C206 103.808 205.991 103.721 205.972 103.615C205.828 91.3537 205.624 84.2238 205.36 82.2256C200.577 45.9764 169.556 18 132 18C95.9151 18 65.8627 43.8283 59 78C53.4772 78 49 83.5964 49 90.5C49 95.0508 50.695 99.1432 53.8535 101.273C54.7582 101.883 56.3238 102.198 58 102.34V102.34Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask5_1_54)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M58 102.34C58 118.921 58 145.474 58 182C58 186.418 61.5817 190 66 190H108V180.611C90.4692 172.283 77.9518 155.115 76.2086 134.867C70.4309 134.002 66 129.019 66 123V110C66 106.509 67.4904 103.367 69.8695 101.174C81.4088 98.5553 93.9707 93.6376 106.342 86.4953C118.473 79.4911 128.844 71.2579 136.821 62.7522C133.394 70.6604 129.245 77.588 124.372 83.535C137.047 78.0121 145.678 69.1324 150.264 56.8961C150.641 57.818 151.035 58.7389 151.444 59.6582C161.7 82.6926 179.318 99.0186 197.206 104.403C197.719 106.513 198 108.484 198 110V123C198 129.019 193.569 134.002 187.791 134.867C186.048 155.115 173.531 172.283 156 180.611V190H174C191.673 190 206 175.673 206 158C206 133.944 206 115.903 206 103.875C206 103.808 205.991 103.721 205.972 103.615C205.828 91.3537 205.624 84.2238 205.36 82.2256C200.577 45.9764 169.556 18 132 18C95.9151 18 65.8627 43.8283 59 78C53.4772 78 49 83.5964 49 90.5C49 95.0508 50.695 99.1432 53.8535 101.273C54.7582 101.883 56.3238 102.198 58 102.34V102.34Z"
                fill="#944F23"
              />
              <path d="M263 0H-1V280H263V0Z" fill="#4A312C" />
            </g>
            <g opacity="0.439991">
              <path
                opacity="0.439991"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M60.899 102.775C74.7109 101.015 90.6793 95.5379 106.342 86.4953C118.473 79.4911 128.844 71.2579 136.821 62.7522C133.394 70.6604 129.245 77.588 124.372 83.535C137.047 78.0121 145.678 69.1324 150.264 56.8961C150.641 57.818 151.035 58.7389 151.444 59.6582C163.382 86.4714 185.296 104.194 206 106.151V92C206 51.1309 172.869 18 132 18C95.9151 18 65.8627 43.8283 59.3213 78.0063C59.2146 78.0021 59.1075 78 59 78C53.4772 78 49 83.5964 49 90.5C49 96.9817 52.9467 102.311 58 102.938V103.093C58.3163 103.064 58.6339 103.033 58.9527 103C58.9685 103 58.9842 103 59 103C59.6493 103 60.2841 102.923 60.899 102.775Z"
                fill="white"
                fillOpacity="0.16"
              />
            </g>
          </g>
        </svg>
      );
    case 2:
      return (
        <svg viewBox="0 -3 264 280" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_1_106"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="36"
            width="200"
            height="244"
          >
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_1_106)">
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="#D0C6AC"
            />
            <path d="M296 36H32V316H296V36Z" fill="#614335" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M188 115V138C188 168.928 162.928 194 132 194C101.072 194 76 168.928 76 138V115V130C76 160.928 101.072 186 132 186C162.928 186 188 160.928 188 130V115Z"
              fill="black"
              fillOpacity="0.1"
            />
          </g>
          <mask
            id="mask1_1_106"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="199"
            width="200"
            height="81"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M105.192 199.052H104C64.2355 199.052 32 231.287 32 271.052V280H232V271.052C232 231.287 199.765 199.052 160 199.052H158.808C158.935 200.035 159 201.036 159 202.052C159 215.859 146.912 227.052 132 227.052C117.088 227.052 105 215.859 105 202.052C105 201.036 105.065 200.035 105.192 199.052Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_1_106)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M105.192 199.052H104C64.2355 199.052 32 231.287 32 271.052V280H232V271.052C232 231.287 199.765 199.052 160 199.052H158.808C158.935 200.035 159 201.036 159 202.052C159 215.859 146.912 227.052 132 227.052C117.088 227.052 105 215.859 105 202.052C105 201.036 105.065 200.035 105.192 199.052Z"
              fill="#E6E6E6"
            />
            <path d="M264 170H0V280H264V170Z" fill="#FF488E" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M156 192.279C162.182 196.835 166 203.106 166 210.028C166 217.233 161.863 223.733 155.229 228.327L149.579 223.876L145 224.208L146 221.057L145.922 220.996C152.022 217.853 156 212.7 156 206.877V192.279ZM108 191.572C101.233 196.174 97 202.74 97 210.028C97 217.426 101.362 224.08 108.308 228.692L114.421 223.876L119 224.208L118 221.057L118.078 220.996C111.978 217.853 108 212.7 108 206.877V191.572Z"
              fill="#F2F2F2"
            />
          </g>
          <mask
            id="mask2_1_106"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="113"
            y="147"
            width="38"
            height="19"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M113.118 149.128C114.176 158.62 122.226 166 132 166C141.804 166 149.874 158.574 150.892 149.04C150.974 148.273 150.117 147 149.043 147C134.149 147 122.738 147 115.087 147C114.007 147 113.012 148.178 113.118 149.128Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_1_106)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M113.118 149.128C114.176 158.62 122.226 166 132 166C141.804 166 149.874 158.574 150.892 149.04C150.974 148.273 150.117 147 149.043 147C134.149 147 122.738 147 115.087 147C114.007 147 113.012 148.178 113.118 149.128Z"
              fill="black"
              fillOpacity="0.7"
            />
            <path
              d="M143 136H122C119.239 136 117 138.239 117 141V147C117 149.761 119.239 152 122 152H143C145.761 152 148 149.761 148 147V141C148 138.239 145.761 136 143 136Z"
              fill="white"
            />
            <path
              d="M127 180C133.075 180 138 175.075 138 169C138 162.925 133.075 158 127 158C120.925 158 116 162.925 116 169C116 175.075 120.925 180 127 180Z"
              fill="#FF4F6D"
            />
            <path
              d="M137 180C143.075 180 148 175.075 148 169C148 162.925 143.075 158 137 158C130.925 158 126 162.925 126 169C126 175.075 130.925 180 137 180Z"
              fill="#FF4F6D"
            />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M120 130C120 134.418 125.373 138 132 138C138.627 138 144 134.418 144 130"
            fill="black"
            fillOpacity="0.16"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M92.1602 112.447C94.0067 108.649 98.1644 106 102.998 106C107.814 106 111.959 108.63 113.815 112.407C114.367 113.529 113.582 114.447 112.791 113.767C110.34 111.66 106.859 110.344 102.998 110.344C99.2572 110.344 95.8738 111.579 93.4375 113.572C92.5468 114.3 91.6201 113.558 92.1602 112.447Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M150.16 112.447C152.007 108.649 156.164 106 160.998 106C165.814 106 169.959 108.63 171.815 112.407C172.367 113.529 171.582 114.447 170.791 113.767C168.34 111.66 164.859 110.344 160.998 110.344C157.257 110.344 153.874 111.579 151.438 113.572C150.547 114.3 149.62 113.558 150.16 112.447Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M98.7664 83.5784L99.6773 83.1758C104.919 81.0947 112.865 81.9671 117.723 84.2991C118.29 84.5715 117.902 85.4519 117.321 85.4071C102.402 84.256 92.3583 93.5526 88.9461 99.8471C88.8449 100.034 88.5392 100.055 88.4635 99.8808C86.1563 94.5621 92.9134 85.8961 98.7664 83.5784Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M165.234 83.5784L164.323 83.1758C159.081 81.0947 151.135 81.9671 146.277 84.2991C145.71 84.5715 146.098 85.4519 146.679 85.4071C161.598 84.256 171.642 93.5526 175.054 99.8471C175.155 100.034 175.461 100.055 175.536 99.8808C177.844 94.5621 171.087 85.8961 165.234 83.5784Z"
            fill="black"
            fillOpacity="0.6"
          />
          <mask
            id="mask3_1_106"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="264"
            height="280"
          >
            <path d="M264 0H0V280H264V0Z" fill="white" />
          </mask>
          <g mask="url(#mask3_1_106)">
            <mask
              id="mask4_1_106"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="72"
              y="19"
              width="118"
              height="82"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M185.832 73.9287C187.589 74.9174 188.98 84.8279 189.048 88.6177C189.09 90.9562 189.127 99.874 186.654 99.1031C185.901 98.8684 184.752 94.1472 184.588 91.3841C184.425 88.6209 182.855 79.22 180.447 74.8947C179.896 73.9063 178.321 72.1709 179.002 71.3348C179.846 70.2981 180.666 70.8996 181.697 71.3147C182.812 71.7642 185.634 73.818 185.832 73.9287ZM186.637 70.9566C185.891 71.9188 180.796 69.2177 178.671 68.044C160.826 58.1841 157.362 55.0487 129.246 55.4578C101.13 55.867 81.8675 69.04 80.784 70.3874C80.0302 71.3249 79.0678 73.8279 78.2764 80.8005C77.485 87.7732 78.4952 100.278 75.6305 100.263C73.1915 100.25 72.6609 76.477 73.7137 67.0464C73.8754 65.5985 74.4984 63.0084 74.0474 61.7059C73.6533 60.5682 71.7254 60.5706 72.0331 58.6751C72.3829 56.5173 74.5585 57.5891 75.506 56.5574C77.3006 54.603 74.5322 54.1404 74.073 52.4307C73.3906 49.8892 75.3628 49.2337 77.1397 48.4311C79.106 47.5438 78.8505 48.3231 80.4464 46.5849C78.3148 45.0225 77.5436 42.8939 80.4624 41.752C81.702 41.2669 84.9269 41.9089 85.8981 41.1802C86.1513 40.9901 86.2515 39.9008 86.4075 39.678C87.9584 37.4594 87.5757 35.8532 87.4184 33.3624C87.289 31.3242 87.3064 29.4532 89.7467 29.2496C91.3751 29.1139 92.6993 30.4442 94.1582 30.8359C95.7768 31.2706 95.1688 31.5878 96.4369 30.715C98.6631 29.1817 97.148 26.1943 98.9133 24.412C101.336 21.9662 102.924 25.5513 104.869 25.8218C109.091 26.4102 107.736 22.1219 110.236 20.5505C113.224 18.6739 113.513 22.8013 115.379 22.9483C116.996 23.0751 119.908 19.9545 121.317 19.3731C125.5 17.6472 127.572 22.5039 131.554 21.8845C134.443 21.4348 135.223 21.0677 137.831 22.7115C140.362 24.3071 140.963 23.1665 143.829 23.1436C145.854 23.1284 147.094 24.8203 148.788 24.9967C149.632 25.0851 150.441 24.2051 151.348 24.2604C154.585 24.4567 154.79 28.643 157.362 29.7956C159.712 30.8488 162.474 29.3691 164.807 29.0953C170.497 28.4275 166.6 33.7425 166.761 36.9147C168.994 37.4359 171.262 35.351 173.485 35.7347C176.987 36.3393 175.665 39.968 174.853 42.4145C177.28 42.3708 183.613 39.6777 185.185 43.122C185.995 44.898 184.107 47.269 184.138 49.0744C184.181 51.6159 186.049 53.7186 186.709 56.124C187.601 59.371 188.872 68.074 186.637 70.9566Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask4_1_106)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M185.832 73.9287C187.589 74.9174 188.98 84.8279 189.048 88.6177C189.09 90.9562 189.127 99.874 186.654 99.1031C185.901 98.8684 184.752 94.1472 184.588 91.3841C184.425 88.6209 182.855 79.22 180.447 74.8947C179.896 73.9063 178.321 72.1709 179.002 71.3348C179.846 70.2981 180.666 70.8996 181.697 71.3147C182.812 71.7642 185.634 73.818 185.832 73.9287ZM186.637 70.9566C185.891 71.9188 180.796 69.2177 178.671 68.044C160.826 58.1841 157.362 55.0487 129.246 55.4578C101.13 55.867 81.8675 69.04 80.784 70.3874C80.0302 71.3249 79.0678 73.8279 78.2764 80.8005C77.485 87.7732 78.4952 100.278 75.6305 100.263C73.1915 100.25 72.6609 76.477 73.7137 67.0464C73.8754 65.5985 74.4984 63.0084 74.0474 61.7059C73.6533 60.5682 71.7254 60.5706 72.0331 58.6751C72.3829 56.5173 74.5585 57.5891 75.506 56.5574C77.3006 54.603 74.5322 54.1404 74.073 52.4307C73.3906 49.8892 75.3628 49.2337 77.1397 48.4311C79.106 47.5438 78.8505 48.3231 80.4464 46.5849C78.3148 45.0225 77.5436 42.8939 80.4624 41.752C81.702 41.2669 84.9269 41.9089 85.8981 41.1802C86.1513 40.9901 86.2515 39.9008 86.4075 39.678C87.9584 37.4594 87.5757 35.8532 87.4184 33.3624C87.289 31.3242 87.3064 29.4532 89.7467 29.2496C91.3751 29.1139 92.6993 30.4442 94.1582 30.8359C95.7768 31.2706 95.1688 31.5878 96.4369 30.715C98.6631 29.1817 97.148 26.1943 98.9133 24.412C101.336 21.9662 102.924 25.5513 104.869 25.8218C109.091 26.4102 107.736 22.1219 110.236 20.5505C113.224 18.6739 113.513 22.8013 115.379 22.9483C116.996 23.0751 119.908 19.9545 121.317 19.3731C125.5 17.6472 127.572 22.5039 131.554 21.8845C134.443 21.4348 135.223 21.0677 137.831 22.7115C140.362 24.3071 140.963 23.1665 143.829 23.1436C145.854 23.1284 147.094 24.8203 148.788 24.9967C149.632 25.0851 150.441 24.2051 151.348 24.2604C154.585 24.4567 154.79 28.643 157.362 29.7956C159.712 30.8488 162.474 29.3691 164.807 29.0953C170.497 28.4275 166.6 33.7425 166.761 36.9147C168.994 37.4359 171.262 35.351 173.485 35.7347C176.987 36.3393 175.665 39.968 174.853 42.4145C177.28 42.3708 183.613 39.6777 185.185 43.122C185.995 44.898 184.107 47.269 184.138 49.0744C184.181 51.6159 186.049 53.7186 186.709 56.124C187.601 59.371 188.872 68.074 186.637 70.9566Z"
                fill="#2E3257"
              />
              <path d="M264 0H0V280H264V0Z" fill="#2C1B18" />
            </g>
          </g>
        </svg>
      );
    case 3:
      return (
        <svg viewBox="0 -3 264 280" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_1_156"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="36"
            width="200"
            height="244"
          >
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_1_156)">
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="#D0C6AC"
            />
            <path d="M296 36H32V316H296V36Z" fill="#AE5D29" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M188 115V138C188 168.928 162.928 194 132 194C101.072 194 76 168.928 76 138V115V130C76 160.928 101.072 186 132 186C162.928 186 188 160.928 188 130V115Z"
              fill="black"
              fillOpacity="0.1"
            />
          </g>
          <mask
            id="mask1_1_156"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="183"
            width="200"
            height="97"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M108 183.071C90.0813 185.076 76.2798 190.552 76.0042 204.645C50.1464 215.568 32 241.165 32 270.999V280H232V270.999C232 241.165 213.854 215.568 187.996 204.645C187.72 190.552 173.919 185.076 156 183.071V202C156 215.255 145.255 226 132 226C118.745 226 108 215.255 108 202V183.071Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_1_156)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M108 183.071C90.0813 185.076 76.2798 190.552 76.0042 204.645C50.1464 215.568 32 241.165 32 270.999V280H232V270.999C232 241.165 213.854 215.568 187.996 204.645C187.72 190.552 173.919 185.076 156 183.071V202C156 215.255 145.255 226 132 226C118.745 226 108 215.255 108 202V183.071Z"
              fill="#B7C1DB"
            />
            <path d="M264 170H0V280H264V170Z" fill="#65C9FF" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M102 231.739V280H95V228.15C97.2038 229.46 99.5468 230.661 102 231.739ZM169 228.15V268.5C169 270.433 167.433 272 165.5 272C163.567 272 162 270.433 162 268.5V231.739C164.453 230.661 166.796 229.46 169 228.15Z"
              fill="#F4F4F4"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M90.9601 182.724C75.9093 185.571 65.5 191.243 65.5 202.308C65.5 222.02 98.5377 238 132 238C165.462 238 198.5 222.02 198.5 202.308C198.5 191.243 188.091 185.571 173.04 182.724C182.125 186.074 188 191.706 188 201.077C188 221.469 160.179 238 132 238C103.821 238 76 221.469 76 201.077C76 191.706 81.8751 186.074 90.9601 182.724Z"
              fill="black"
              fillOpacity="0.16"
            />
          </g>
          <path
            d="M141 152H123C121.343 152 120 153.343 120 155C120 156.657 121.343 158 123 158H141C142.657 158 144 156.657 144 155C144 153.343 142.657 152 141 152Z"
            fill="black"
            fillOpacity="0.7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M120 130C120 134.418 125.373 138 132 138C138.627 138 144 134.418 144 130"
            fill="black"
            fillOpacity="0.16"
          />
          <path
            d="M106 118C109.314 118 112 115.314 112 112C112 108.686 109.314 106 106 106C102.686 106 100 108.686 100 112C100 115.314 102.686 118 106 118Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            d="M158 118C161.314 118 164 115.314 164 112C164 108.686 161.314 106 158 106C154.686 106 152 108.686 152 112C152 115.314 154.686 118 158 118Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M102.547 88.1484C96.7404 88.4166 87.3523 92.6363 87.5942 98.4922C87.6022 98.6839 87.8837 98.768 88.0213 98.6206C90.7762 95.6613 110.337 92.6709 117.226 94.2556C117.857 94.4008 118.336 93.7788 117.936 93.3294C114.514 89.4812 107.75 87.903 102.547 88.1484Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M162.453 88.1484C168.26 88.4166 177.648 92.6363 177.406 98.4922C177.398 98.6839 177.116 98.768 176.979 98.6206C174.224 95.6613 154.664 92.6709 147.774 94.2556C147.143 94.4008 146.664 93.7788 147.064 93.3294C150.486 89.4812 157.25 87.903 162.453 88.1484Z"
            fill="black"
            fillOpacity="0.6"
          />
          <mask
            id="mask2_1_156"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="264"
            height="280"
          >
            <path d="M264 0H0V280H264V0Z" fill="white" />
          </mask>
          <g mask="url(#mask2_1_156)">
            <mask
              id="mask3_1_156"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="75"
              y="98"
              width="114"
              height="89"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M149.428 170.169C146.915 172.463 144.237 173.494 140.853 172.773C140.271 172.649 137.896 168.235 132 168.235C126.103 168.235 123.729 172.649 123.147 172.773C119.762 173.494 117.085 172.463 114.571 170.169C109.846 165.856 105.917 159.908 108.278 153.419C109.508 150.037 111.51 146.324 115.151 145.246C119.038 144.096 124.497 145.244 128.415 144.458C129.684 144.204 131.071 143.751 132 143C132.929 143.751 134.316 144.204 135.585 144.458C139.503 145.244 144.961 144.096 148.849 145.246C152.49 146.324 154.491 150.037 155.722 153.419C158.083 159.908 154.154 165.856 149.428 170.169ZM188.081 98C184.671 106.4 185.988 116.858 185.357 125.676C184.844 132.843 183.337 143.586 176.973 148.215C173.718 150.582 167.794 154.56 163.542 153.45C160.615 152.686 160.302 144.29 156.455 141.147C152.092 137.582 146.643 136.016 141.149 136.258C138.779 136.362 133.984 136.337 132 138.16C130.016 136.337 125.222 136.362 122.851 136.258C117.357 136.016 111.908 137.582 107.545 141.147C103.698 144.29 103.386 152.686 100.458 153.45C96.2058 154.56 90.2818 150.582 87.027 148.215C80.6624 143.586 79.1562 132.843 78.6429 125.676C78.0121 116.858 79.3292 106.4 75.9188 98C74.2598 98 75.354 114.129 75.354 114.129V134.485C75.3857 149.773 84.9351 172.655 106.108 181.393C111.286 183.53 123.015 187 132 187C140.985 187 152.714 183.86 157.892 181.723C179.065 172.986 188.614 149.773 188.646 134.485V114.129C188.646 114.129 189.74 98 188.081 98Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask3_1_156)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M149.428 170.169C146.915 172.463 144.237 173.494 140.853 172.773C140.271 172.649 137.896 168.235 132 168.235C126.103 168.235 123.729 172.649 123.147 172.773C119.762 173.494 117.085 172.463 114.571 170.169C109.846 165.856 105.917 159.908 108.278 153.419C109.508 150.037 111.51 146.324 115.151 145.246C119.038 144.096 124.497 145.244 128.415 144.458C129.684 144.204 131.071 143.751 132 143C132.929 143.751 134.316 144.204 135.585 144.458C139.503 145.244 144.961 144.096 148.849 145.246C152.49 146.324 154.491 150.037 155.722 153.419C158.083 159.908 154.154 165.856 149.428 170.169ZM188.081 98C184.671 106.4 185.988 116.858 185.357 125.676C184.844 132.843 183.337 143.586 176.973 148.215C173.718 150.582 167.794 154.56 163.542 153.45C160.615 152.686 160.302 144.29 156.455 141.147C152.092 137.582 146.643 136.016 141.149 136.258C138.779 136.362 133.984 136.337 132 138.16C130.016 136.337 125.222 136.362 122.851 136.258C117.357 136.016 111.908 137.582 107.545 141.147C103.698 144.29 103.386 152.686 100.458 153.45C96.2058 154.56 90.2818 150.582 87.027 148.215C80.6624 143.586 79.1562 132.843 78.6429 125.676C78.0121 116.858 79.3292 106.4 75.9188 98C74.2598 98 75.354 114.129 75.354 114.129V134.485C75.3857 149.773 84.9351 172.655 106.108 181.393C111.286 183.53 123.015 187 132 187C140.985 187 152.714 183.86 157.892 181.723C179.065 172.986 188.614 149.773 188.646 134.485V114.129C188.646 114.129 189.74 98 188.081 98Z"
                fill="#331B0C"
              />
              <path d="M280 72H16V316H280V72Z" fill="#4A312C" />
            </g>
            <mask
              id="mask4_1_156"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="74"
              y="34"
              width="116"
              height="66"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M156.018 58.3785C148.986 57.6847 140.657 57.2515 132.313 57.2456C113.008 57.2319 93.6182 59.4834 90 62C80.296 69.2481 76.5373 96.4457 77 98C76.6728 99.2227 75.3469 99.4884 75 98C74.2808 87.7019 75 35.7256 132 35C189 34.2744 189.719 87.7019 189 98C188.653 99.4884 187.327 99.2227 187 98C187.463 96.4457 183.704 69.2481 174 62C172.241 60.7763 166.753 59.6102 159.359 58.739L163 50L156.018 58.3785Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask4_1_156)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M156.018 58.3785C148.986 57.6847 140.657 57.2515 132.313 57.2456C113.008 57.2319 93.6182 59.4834 90 62C80.296 69.2481 76.5373 96.4457 77 98C76.6728 99.2227 75.3469 99.4884 75 98C74.2808 87.7019 75 35.7256 132 35C189 34.2744 189.719 87.7019 189 98C188.653 99.4884 187.327 99.2227 187 98C187.463 96.4457 183.704 69.2481 174 62C172.241 60.7763 166.753 59.6102 159.359 58.739L163 50L156.018 58.3785Z"
                fill="#28354B"
              />
              <path d="M338 34H74V314H338V34Z" fill="#4A312C" />
            </g>
          </g>
        </svg>
      );
    case 4:
      return (
        <svg viewBox="0 -3 264 280" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_1_266"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="36"
            width="200"
            height="244"
          >
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_1_266)">
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="#D0C6AC"
            />
            <path d="M296 36H32V316H296V36Z" fill="#FFDBB4" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M188 115V138C188 168.928 162.928 194 132 194C101.072 194 76 168.928 76 138V115V130C76 160.928 101.072 186 132 186C162.928 186 188 160.928 188 130V115Z"
              fill="black"
              fillOpacity="0.1"
            />
          </g>
          <mask
            id="mask1_1_266"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="202"
            width="200"
            height="78"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M181.544 202.33C210.784 211.488 232 238.792 232 271.052V280H32V271.052C32 238.397 53.7388 210.82 83.534 202.002C83.1822 203.42 83 204.871 83 206.348C83 222.629 105.162 235.828 132.5 235.828C159.838 235.828 182 222.629 182 206.348C182 204.985 181.845 203.644 181.544 202.33Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_1_266)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M181.544 202.33C210.784 211.488 232 238.792 232 271.052V280H32V271.052C32 238.397 53.7388 210.82 83.534 202.002C83.1822 203.42 83 204.871 83 206.348C83 222.629 105.162 235.828 132.5 235.828C159.838 235.828 182 222.629 182 206.348C182 204.985 181.845 203.644 181.544 202.33Z"
              fill="#E6E6E6"
            />
            <path d="M264 170H0V280H264V170Z" fill="#FF5C5C" />
          </g>
          <mask
            id="mask2_1_266"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="106"
            y="147"
            width="52"
            height="20"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M107 149.609C108.41 159.231 119.062 167 132 167C144.968 167 155.646 159.183 157 148.739C157.101 148.34 156.775 147 154.826 147C134.838 147 119.74 147 109.174 147C107.383 147 106.87 148.24 107 149.609Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_1_266)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M107 149.609C108.41 159.231 119.062 167 132 167C144.968 167 155.646 159.183 157 148.739C157.101 148.34 156.775 147 154.826 147C134.838 147 119.74 147 109.174 147C107.383 147 106.87 148.24 107 149.609Z"
              fill="black"
              fillOpacity="0.7"
            />
            <path
              d="M143 136H122C119.239 136 117 138.239 117 141V147C117 149.761 119.239 152 122 152H143C145.761 152 148 149.761 148 147V141C148 138.239 145.761 136 143 136Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M143.984 157.747C143.995 157.83 144 157.914 144 158V167C144 173.075 139.075 178 133 178H132C125.925 178 121 173.075 121 167V158C121 157.914 121.005 157.83 121.016 157.747C121.005 157.665 121 157.583 121 157.5C121 155.567 123.91 154 127.5 154C129.51 154 131.308 154.491 132.5 155.263C133.692 154.491 135.49 154 137.5 154C141.09 154 144 155.567 144 157.5C144 157.583 143.995 157.665 143.984 157.747Z"
              fill="#FF4F6D"
            />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M120 130C120 134.418 125.373 138 132 138C138.627 138 144 134.418 144 130"
            fill="black"
            fillOpacity="0.16"
          />
          <path
            d="M106 126C113.732 126 120 119.732 120 112C120 104.268 113.732 98 106 98C98.2681 98 92.0001 104.268 92.0001 112C92.0001 119.732 98.2681 126 106 126Z"
            fill="white"
          />
          <path
            d="M158 126C165.732 126 172 119.732 172 112C172 104.268 165.732 98 158 98C150.268 98 144 104.268 144 112C144 119.732 150.268 126 158 126Z"
            fill="white"
          />
          <path
            d="M106 110C109.314 110 112 107.314 112 104C112 100.686 109.314 98 106 98C102.686 98 100 100.686 100 104C100 107.314 102.686 110 106 110Z"
            fill="black"
            fillOpacity="0.7"
          />
          <path
            d="M158 110C161.314 110 164 107.314 164 104C164 100.686 161.314 98 158 98C154.686 98 152 100.686 152 104C152 107.314 154.686 110 158 110Z"
            fill="black"
            fillOpacity="0.7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M102.547 88.1484C96.7404 88.4166 87.3523 92.6363 87.5942 98.4922C87.6022 98.6839 87.8837 98.768 88.0213 98.6206C90.7762 95.6613 110.337 92.6709 117.226 94.2556C117.857 94.4008 118.336 93.7788 117.936 93.3294C114.514 89.4812 107.75 87.903 102.547 88.1484Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M162.453 88.1484C168.26 88.4166 177.648 92.6363 177.406 98.4922C177.398 98.6839 177.116 98.768 176.979 98.6206C174.224 95.6613 154.664 92.6709 147.774 94.2556C147.143 94.4008 146.664 93.7788 147.064 93.3294C150.486 89.4812 157.25 87.903 162.453 88.1484Z"
            fill="black"
            fillOpacity="0.6"
          />
          <mask
            id="mask3_1_266"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="264"
            height="280"
          >
            <path d="M264 0H0V280H264V0Z" fill="white" />
          </mask>
          <g mask="url(#mask3_1_266)">
            <mask
              id="mask4_1_266"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="64"
              y="4"
              width="136"
              height="69"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M193.659 42.3566C196.46 49.3577 198 56.999 198 65V73H66V65C66 56.9749 67.5497 49.3117 70.3662 42.2934C63.9628 28.8305 62.7194 17.7728 66.6361 9.12029C74.141 6.84356 82.8342 8.64979 92.7157 14.539C102.486 7.88774 114.289 4 127 4H137C149.722 4 161.535 7.89461 171.31 14.5566C181.204 8.6534 189.907 6.84129 197.419 9.12029C201.342 17.7863 200.089 28.8651 193.659 42.3566Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask4_1_266)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M193.659 42.3566C196.46 49.3577 198 56.999 198 65V73H66V65C66 56.9749 67.5497 49.3117 70.3662 42.2934C63.9628 28.8305 62.7194 17.7728 66.6361 9.12029C74.141 6.84356 82.8342 8.64979 92.7157 14.539C102.486 7.88774 114.289 4 127 4H137C149.722 4 161.535 7.89461 171.31 14.5566C181.204 8.6534 189.907 6.84129 197.419 9.12029C201.342 17.7863 200.089 28.8651 193.659 42.3566Z"
                fill="#D8D8D8"
              />
              <path d="M328 4H64V284H328V4Z" fill="#FF5C5C" />
            </g>
            <mask
              id="mask5_1_266"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="64"
              y="8"
              width="136"
              height="35"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M92.7157 14.539C82.7587 21.3171 74.9123 30.9652 70.3662 42.2934C63.9628 28.8305 62.7194 17.7728 66.6361 9.12028C74.141 6.84355 82.8342 8.64978 92.7157 14.539L92.7157 14.539ZM193.659 42.3566C189.121 31.0109 181.273 21.3464 171.31 14.5566C181.204 8.65339 189.907 6.84128 197.419 9.12028C201.342 17.7863 200.089 28.8651 193.659 42.3566Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask5_1_266)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M92.7157 14.539C82.7587 21.3171 74.9123 30.9652 70.3662 42.2934C63.9628 28.8305 62.7194 17.7728 66.6361 9.12028C74.141 6.84355 82.8342 8.64978 92.7157 14.539L92.7157 14.539ZM193.659 42.3566C189.121 31.0109 181.273 21.3464 171.31 14.5566C181.204 8.65339 189.907 6.84128 197.419 9.12028C201.342 17.7863 200.089 28.8651 193.659 42.3566Z"
                fill="black"
                fillOpacity="0.24"
              />
            </g>
            <mask
              id="mask6_1_266"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="71"
              y="16"
              width="121"
              height="19"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M85.8615 19.9591C81.3889 24.0466 77.5271 28.7913 74.4291 34.0405C71.5035 25.9322 71.0028 20.3214 72.927 17.2081C75.5782 16.0616 79.8897 16.9786 85.8615 19.9591ZM189.353 33.6737C186.278 28.5465 182.472 23.9084 178.078 19.9038C183.88 17.052 188.083 16.1889 190.686 17.3145C192.572 20.3668 192.128 25.8199 189.353 33.6737Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask6_1_266)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M85.8615 19.9591C81.3889 24.0466 77.5271 28.7913 74.4291 34.0405C71.5035 25.9322 71.0028 20.3214 72.927 17.2081C75.5782 16.0616 79.8897 16.9786 85.8615 19.9591ZM189.353 33.6737C186.278 28.5465 182.472 23.9084 178.078 19.9038C183.88 17.052 188.083 16.1889 190.686 17.3145C192.572 20.3668 192.128 25.8199 189.353 33.6737Z"
                fill="white"
                fillOpacity="0.3"
              />
            </g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M66.2846 61.4514C82.2297 49.8171 104.159 44 132.073 44C159.985 44 181.872 49.8165 197.732 61.4496V61.4496C199.786 62.9567 201 65.3523 201 67.9004V98.3698C201 100.579 199.209 102.37 197 102.37C196.244 102.37 195.504 102.156 194.865 101.753C178.223 91.2509 157.536 86 132.804 86C107.883 86 86.6404 91.3315 69.0757 101.994V101.994C67.1873 103.141 64.7271 102.539 63.5807 100.651C63.2009 100.025 63 99.3072 63 98.5751L63 67.914C63 65.3589 64.2205 62.9575 66.2846 61.4514Z"
              fill="black"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M66.2846 61.4514C82.2297 49.8171 104.159 44 132.073 44C159.985 44 181.872 49.8165 197.732 61.4496V61.4496C199.786 62.9567 201 65.3523 201 67.9004V98.3698C201 100.579 199.209 102.37 197 102.37C196.244 102.37 195.504 102.156 194.865 101.753C178.223 91.2509 157.536 86 132.804 86C107.883 86 86.6404 91.3315 69.0757 101.994V101.994C67.1873 103.141 64.7271 102.539 63.5807 100.651C63.2009 100.025 63 99.3072 63 98.5751L63 67.914C63 65.3589 64.2205 62.9575 66.2846 61.4514Z"
              fill="#F4F4F4"
            />
            <g filter="url(#filter0_d_1_266)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M141.465 101.394C145.38 93.4587 153.553 88 163 88C171.92 88 179.703 92.8659 183.84 100.088C184.05 100.031 184.272 100 184.5 100H192.5C193.881 100 195 101.119 195 102.5C195 103.881 193.881 105 192.5 105H185.963C186.637 107.215 187 109.565 187 112C187 125.255 176.255 136 163 136C149.745 136 139 125.255 139 112C139 110.578 139.124 109.185 139.361 107.831C139.276 103.455 135.914 100 131.862 100C128.126 100 124.975 102.94 124.442 106.83C124.807 108.495 125 110.225 125 112C125 125.255 114.255 136 101 136C87.7452 136 77 125.255 77 112C77 109.565 77.3626 107.215 78.0369 105H71.5C70.1193 105 69 103.881 69 102.5C69 101.119 70.1193 100 71.5 100H79.5C79.7285 100 79.9498 100.031 80.1601 100.088C84.2971 92.8659 92.0803 88 101 88C110.352 88 118.455 93.3492 122.416 101.155C124.493 98.0393 127.949 96 131.862 96C135.875 96 139.407 98.1441 141.465 101.394ZM101 132C112.046 132 121 123.046 121 112C121 100.954 112.046 92 101 92C89.9543 92 81 100.954 81 112C81 123.046 89.9543 132 101 132ZM163 132C174.046 132 183 123.046 183 112C183 100.954 174.046 92 163 92C151.954 92 143 100.954 143 112C143 123.046 151.954 132 163 132Z"
                fill="black"
              />
            </g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M141.465 101.394C145.38 93.4587 153.553 88 163 88C171.92 88 179.703 92.8659 183.84 100.088C184.05 100.031 184.272 100 184.5 100H192.5C193.881 100 195 101.119 195 102.5C195 103.881 193.881 105 192.5 105H185.963C186.637 107.215 187 109.565 187 112C187 125.255 176.255 136 163 136C149.745 136 139 125.255 139 112C139 110.578 139.124 109.185 139.361 107.831C139.276 103.455 135.914 100 131.862 100C128.126 100 124.975 102.94 124.442 106.83C124.807 108.495 125 110.225 125 112C125 125.255 114.255 136 101 136C87.7452 136 77 125.255 77 112C77 109.565 77.3626 107.215 78.0369 105H71.5C70.1193 105 69 103.881 69 102.5C69 101.119 70.1193 100 71.5 100H79.5C79.7285 100 79.9498 100.031 80.1601 100.088C84.2971 92.8659 92.0803 88 101 88C110.352 88 118.455 93.3492 122.416 101.155C124.493 98.0393 127.949 96 131.862 96C135.875 96 139.407 98.1441 141.465 101.394ZM101 132C112.046 132 121 123.046 121 112C121 100.954 112.046 92 101 92C89.9543 92 81 100.954 81 112C81 123.046 89.9543 132 101 132ZM163 132C174.046 132 183 123.046 183 112C183 100.954 174.046 92 163 92C151.954 92 143 100.954 143 112C143 123.046 151.954 132 163 132Z"
              fill="#252C2F"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_1_266"
              x="65"
              y="86"
              width="134"
              height="56"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="2" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_266" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_266" result="shape" />
            </filter>
          </defs>
        </svg>
      );
    case 5:
      return (
        <svg viewBox="0 -3 264 280" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_1_482"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="36"
            width="200"
            height="244"
          >
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_1_482)">
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="#D0C6AC"
            />
            <path d="M296 36H32V316H296V36Z" fill="#614335" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M188 115V138C188 168.928 162.928 194 132 194C101.072 194 76 168.928 76 138V115V130C76 160.928 101.072 186 132 186C162.928 186 188 160.928 188 130V115Z"
              fill="black"
              fillOpacity="0.1"
            />
          </g>
          <mask
            id="mask1_1_482"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="202"
            width="200"
            height="78"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M181.544 202.33C210.784 211.488 232 238.792 232 271.052V280H32V271.052C32 238.397 53.7388 210.82 83.534 202.002C83.1822 203.42 83 204.871 83 206.348C83 222.629 105.162 235.828 132.5 235.828C159.838 235.828 182 222.629 182 206.348C182 204.985 181.845 203.644 181.544 202.33Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_1_482)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M181.544 202.33C210.784 211.488 232 238.792 232 271.052V280H32V271.052C32 238.397 53.7388 210.82 83.534 202.002C83.1822 203.42 83 204.871 83 206.348C83 222.629 105.162 235.828 132.5 235.828C159.838 235.828 182 222.629 182 206.348C182 204.985 181.845 203.644 181.544 202.33Z"
              fill="#E6E6E6"
            />
            <path d="M264 170H0V280H264V170Z" fill="#FF5C5C" />
          </g>
          <g opacity="0.6">
            <path
              opacity="0.6"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M122.191 150.106C122.018 144.996 117.792 140.797 112.294 140C115.66 141.959 117.98 145.495 117.98 149.677C117.98 155.345 112.507 160.245 106.177 160.245C106.118 160.245 106.059 160.245 106 160.244H106C107.358 160.732 108.84 161 110.392 161C115.714 161 120.213 157.847 121.686 153.514C124.161 155.67 127.863 157.039 132 157.039C136.137 157.039 139.839 155.67 142.314 153.514C143.787 157.847 148.286 161 153.608 161C155.16 161 156.642 160.732 158 160.244C157.941 160.245 157.882 160.245 157.823 160.245C151.493 160.245 146.02 155.345 146.02 149.677C146.02 145.495 148.34 141.959 151.706 140C146.208 140.797 141.982 144.996 141.809 150.106C139.245 151.842 135.795 152.906 132 152.906C128.205 152.906 124.755 151.842 122.191 150.106Z"
              fill="black"
              fillOpacity="0.6"
            />
          </g>
          <path
            d="M95 158C99.9706 158 104 153.971 104 149C104 144.029 99.9706 140 95 140C90.0294 140 86 144.029 86 149C86 153.971 90.0294 158 95 158Z"
            fill="#FF4646"
            fillOpacity="0.2"
          />
          <path
            d="M169 158C173.971 158 178 153.971 178 149C178 144.029 173.971 140 169 140C164.029 140 160 144.029 160 149C160 153.971 164.029 158 169 158Z"
            fill="#FF4646"
            fillOpacity="0.2"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M120 130C120 134.418 125.373 138 132 138C138.627 138 144 134.418 144 130"
            fill="black"
            fillOpacity="0.16"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M103.241 110.346C102.463 111.357 102 112.625 102 114C102 117.314 104.686 120 108 120C111.314 120 114 117.314 114 114C114 113.71 113.979 113.424 113.94 113.145C113.947 112.923 113.91 112.671 113.815 112.407C113.77 112.281 113.722 112.157 113.671 112.035C113.337 111.072 112.765 110.22 112.025 109.551C109.899 107.317 106.506 106 102.998 106C98.1644 106 94.0067 108.649 92.1602 112.447C91.6201 113.558 92.5468 114.3 93.4375 113.572C95.8738 111.579 99.2572 110.344 102.998 110.344C103.079 110.344 103.16 110.344 103.241 110.346Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M161.241 110.346C160.463 111.357 160 112.625 160 114C160 117.314 162.686 120 166 120C169.314 120 172 117.314 172 114C172 113.71 171.979 113.424 171.94 113.145C171.947 112.923 171.91 112.671 171.815 112.407C171.77 112.281 171.722 112.157 171.671 112.035C171.337 111.072 170.765 110.22 170.025 109.551C167.899 107.317 164.506 106 160.998 106C156.164 106 152.007 108.649 150.16 112.447C149.62 113.558 150.547 114.3 151.438 113.572C153.874 111.579 157.257 110.344 160.998 110.344C161.079 110.344 161.16 110.344 161.241 110.346Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M102.547 88.1484C96.7404 88.4166 87.3522 92.6363 87.5941 98.4922C87.6021 98.6839 87.8837 98.768 88.0212 98.6206C90.7761 95.6613 110.337 92.6709 117.226 94.2556C117.857 94.4008 118.336 93.7788 117.936 93.3294C114.514 89.4812 107.75 87.903 102.547 88.1484Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M162.453 88.1484C168.26 88.4166 177.648 92.6363 177.406 98.4922C177.398 98.6839 177.116 98.768 176.979 98.6206C174.224 95.6613 154.663 92.6709 147.774 94.2556C147.143 94.4008 146.664 93.7788 147.064 93.3294C150.486 89.4812 157.25 87.903 162.453 88.1484Z"
            fill="black"
            fillOpacity="0.6"
          />
          <mask
            id="mask2_1_482"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="264"
            height="280"
          >
            <path d="M264 0H0V280H264V0Z" fill="white" />
          </mask>
          <g mask="url(#mask2_1_482)">
            <mask
              id="mask3_1_482"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="73"
              y="0"
              width="118"
              height="99"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M113.94 28.3372C112.954 28.5587 111.986 28.7906 111.037 29.03C95.9448 32.838 87.0168 43.6513 79.3567 59.6481C75.5956 67.5029 73.366 76.7915 73.0231 85.4814C72.8884 88.8933 73.3484 92.4152 74.2677 95.7004C74.6049 96.9062 76.4232 101.087 76.9225 97.7088C77.0885 96.5843 76.4804 95.0328 76.4216 93.8376C76.3444 92.2694 76.4273 90.6808 76.5342 89.1149C76.7341 86.1874 77.256 83.3154 78.1847 80.5247C79.5119 76.5367 81.2014 72.2129 83.7874 68.8481C90.1884 60.5206 94.7648 43.2055 132 41.6707C169.235 40.1359 180.749 67.4611 184.183 73.3007C188.248 80.2147 186.378 88.7074 187.619 96.2008C188.091 99.0504 189.164 98.9866 189.751 96.4378C190.748 92.1083 191.219 87.6102 190.902 83.1593C190.184 73.1115 186.497 46.7057 166.309 35.0061C160.867 31.8521 155.438 29.6875 150.117 28.2828C153.176 25.3111 155 21.5676 155 17.5C155 7.83502 144.703 0 132 0C119.297 0 109 7.83502 109 17.5C109 21.5925 110.846 25.3569 113.94 28.3372Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask3_1_482)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M113.94 28.3372C112.954 28.5587 111.986 28.7906 111.037 29.03C95.9448 32.838 87.0168 43.6513 79.3567 59.6481C75.5956 67.5029 73.366 76.7915 73.0231 85.4814C72.8884 88.8933 73.3484 92.4152 74.2677 95.7004C74.6049 96.9062 76.4232 101.087 76.9225 97.7088C77.0885 96.5843 76.4804 95.0328 76.4216 93.8376C76.3444 92.2694 76.4273 90.6808 76.5342 89.1149C76.7341 86.1874 77.256 83.3154 78.1847 80.5247C79.5119 76.5367 81.2014 72.2129 83.7874 68.8481C90.1884 60.5206 94.7648 43.2055 132 41.6707C169.235 40.1359 180.749 67.4611 184.183 73.3007C188.248 80.2147 186.378 88.7074 187.619 96.2008C188.091 99.0504 189.164 98.9866 189.751 96.4378C190.748 92.1083 191.219 87.6102 190.902 83.1593C190.184 73.1115 186.497 46.7057 166.309 35.0061C160.867 31.8521 155.438 29.6875 150.117 28.2828C153.176 25.3111 155 21.5676 155 17.5C155 7.83502 144.703 0 132 0C119.297 0 109 7.83502 109 17.5C109 21.5925 110.846 25.3569 113.94 28.3372Z"
                fill="#28354B"
              />
              <path d="M263 0H-1V280H263V0Z" fill="#2C1B18" />
            </g>
          </g>
        </svg>
      );
    case 6:
      return (
        <svg viewBox="0 -3 264 280" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_1_526"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="36"
            width="200"
            height="244"
          >
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_1_526)">
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="#D0C6AC"
            />
            <path d="M296 36H32V316H296V36Z" fill="#AE5D29" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M188 115V138C188 168.928 162.928 194 132 194C101.072 194 76 168.928 76 138V115V130C76 160.928 101.072 186 132 186C162.928 186 188 160.928 188 130V115Z"
              fill="black"
              fillOpacity="0.1"
            />
          </g>
          <mask
            id="mask1_1_526"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="199"
            width="200"
            height="81"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M165.96 199.295C202.936 202.325 232 233.294 232 271.052V280H32V271.052C32 232.953 61.592 201.765 99.0454 199.22C99.0153 199.593 99 199.969 99 200.348C99 212.211 113.998 221.828 132.5 221.828C151.002 221.828 166 212.211 166 200.348C166 199.995 165.987 199.644 165.96 199.295Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_1_526)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M165.96 199.295C202.936 202.325 232 233.294 232 271.052V280H32V271.052C32 232.953 61.592 201.765 99.0454 199.22C99.0153 199.593 99 199.969 99 200.348C99 212.211 113.998 221.828 132.5 221.828C151.002 221.828 166 212.211 166 200.348C166 199.995 165.987 199.644 165.96 199.295Z"
              fill="#E6E6E6"
            />
            <path d="M264 170H0V280H264V170Z" fill="#A7FFC4" />
            <g opacity="0.6">
              <g opacity="0.6">
                <path
                  opacity="0.6"
                  d="M132.5 228.761C154.39 228.761 172.135 216.712 172.135 201.848C172.135 186.984 154.39 174.934 132.5 174.934C110.61 174.934 92.8649 186.984 92.8649 201.848C92.8649 216.712 110.61 228.761 132.5 228.761Z"
                  fill="black"
                  fillOpacity="0.16"
                />
              </g>
            </g>
          </g>
          <path
            d="M118 150C118 155.372 124.158 159 132 159C139.842 159 146 155.372 146 150C146 148.895 145.05 148 144 148C142.707 148 142.13 148.905 142 150C140.758 152.938 137.683 154.716 132 155C126.317 154.716 123.242 152.938 122 150C121.87 148.905 121.293 148 120 148C118.95 148 118 148.895 118 150Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M120 130C120 134.418 125.373 138 132 138C138.627 138 144 134.418 144 130"
            fill="black"
            fillOpacity="0.16"
          />
          <path
            d="M106 118C109.314 118 112 115.314 112 112C112 108.686 109.314 106 106 106C102.686 106 100 108.686 100 112C100 115.314 102.686 118 106 118Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            d="M158 118C161.314 118 164 115.314 164 112C164 108.686 161.314 106 158 106C154.686 106 152 108.686 152 112C152 115.314 154.686 118 158 118Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M102.547 88.1484C96.7404 88.4166 87.3522 92.6363 87.5941 98.4922C87.6021 98.6839 87.8837 98.768 88.0212 98.6206C90.7761 95.6613 110.337 92.6709 117.226 94.2556C117.857 94.4008 118.336 93.7788 117.936 93.3294C114.514 89.4812 107.75 87.903 102.547 88.1484Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M162.453 88.1484C168.26 88.4166 177.648 92.6363 177.406 98.4922C177.398 98.6839 177.116 98.768 176.979 98.6206C174.224 95.6613 154.663 92.6709 147.774 94.2556C147.143 94.4008 146.664 93.7788 147.064 93.3294C150.486 89.4812 157.25 87.903 162.453 88.1484Z"
            fill="black"
            fillOpacity="0.6"
          />
          <mask
            id="mask2_1_526"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="264"
            height="280"
          >
            <path d="M264 0H0V280H264V0Z" fill="white" />
          </mask>
          <g mask="url(#mask2_1_526)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M68.0331 76.2129C80.9709 43.1292 94.6459 26.5874 109.058 26.5874C109.597 26.5874 138.311 26.3494 157.113 26.2268C177.767 35.5853 192 55.3036 192 78.1146V93H109.058L106.253 69.8204L102.374 93H68V78.1146C68 77.4782 68.0111 76.8443 68.0331 76.2129L68.0331 76.2129Z"
              fill="black"
              fillOpacity="0.16"
            />
            <mask
              id="mask3_1_526"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="38"
              y="19"
              width="188"
              height="177"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M187.859 88C187.953 89.3212 188 90.6551 188 92V130C188 152.339 174.92 171.623 156 180.611V189.317C174.146 190.816 191.721 193.335 202 196C211.953 182.439 224.885 169.8 225 145C225.085 126.015 197.324 49.4276 185 34C176.862 23.8121 156.305 20.4493 132 20C107.695 19.5506 87.9231 25.5088 80 35C69.319 47.795 38.915 126.015 39 145C39.1156 169.8 52.0475 182.439 62 196C72.279 193.335 89.8545 190.816 108 189.317V180.611C89.0804 171.623 76 152.339 76 130V92C76 90.6551 76.0474 89.3212 76.1407 88H104.374L108.253 66.5561L111.058 88H187.859Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask3_1_526)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M187.859 88C187.953 89.3212 188 90.6551 188 92V130C188 152.339 174.92 171.623 156 180.611V189.317C174.146 190.816 191.721 193.335 202 196C211.953 182.439 224.885 169.8 225 145C225.085 126.015 197.324 49.4276 185 34C176.862 23.8121 156.305 20.4493 132 20C107.695 19.5506 87.9231 25.5088 80 35C69.319 47.795 38.915 126.015 39 145C39.1156 169.8 52.0475 182.439 62 196C72.279 193.335 89.8545 190.816 108 189.317V180.611C89.0804 171.623 76 152.339 76 130V92C76 90.6551 76.0474 89.3212 76.1407 88H104.374L108.253 66.5561L111.058 88H187.859Z"
                fill="#E6E6E6"
              />
              <path d="M303 19H39V299H303V19Z" fill="#2C1B18" />
            </g>
          </g>
        </svg>
      );
    case 7:
      return (
        <svg viewBox="0 -3 264 280" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_1_572"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="36"
            width="200"
            height="244"
          >
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_1_572)">
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="#D0C6AC"
            />
            <path d="M296 36H32V316H296V36Z" fill="#D08B5B" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M188 115V138C188 168.928 162.928 194 132 194C101.072 194 76 168.928 76 138V115V130C76 160.928 101.072 186 132 186C162.928 186 188 160.928 188 130V115Z"
              fill="black"
              fillOpacity="0.1"
            />
          </g>
          <mask
            id="mask1_1_572"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="199"
            width="200"
            height="81"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M165.96 199.295C202.936 202.325 232 233.294 232 271.052V280H32V271.052C32 232.953 61.592 201.765 99.0454 199.22C99.0153 199.593 99 199.969 99 200.348C99 212.211 113.998 221.828 132.5 221.828C151.002 221.828 166 212.211 166 200.348C166 199.995 165.987 199.644 165.96 199.295Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_1_572)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M165.96 199.295C202.936 202.325 232 233.294 232 271.052V280H32V271.052C32 232.953 61.592 201.765 99.0454 199.22C99.0153 199.593 99 199.969 99 200.348C99 212.211 113.998 221.828 132.5 221.828C151.002 221.828 166 212.211 166 200.348C166 199.995 165.987 199.644 165.96 199.295Z"
              fill="#E6E6E6"
            />
            <path d="M264 170H0V280H264V170Z" fill="#FFDEB5" />
            <g opacity="0.6">
              <g opacity="0.6">
                <path
                  opacity="0.6"
                  d="M132.5 228.761C154.39 228.761 172.135 216.712 172.135 201.848C172.135 186.984 154.39 174.934 132.5 174.934C110.61 174.934 92.8649 186.984 92.8649 201.848C92.8649 216.712 110.61 228.761 132.5 228.761Z"
                  fill="black"
                  fillOpacity="0.16"
                />
              </g>
            </g>
          </g>
          <mask
            id="mask2_1_572"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="106"
            y="147"
            width="52"
            height="20"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M107 149.609C108.41 159.231 119.062 167 132 167C144.968 167 155.646 159.183 157 148.739C157.101 148.34 156.775 147 154.826 147C134.838 147 119.74 147 109.174 147C107.383 147 106.87 148.24 107 149.609Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_1_572)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M107 149.609C108.41 159.231 119.062 167 132 167C144.968 167 155.646 159.183 157 148.739C157.101 148.34 156.775 147 154.826 147C134.838 147 119.74 147 109.174 147C107.383 147 106.87 148.24 107 149.609Z"
              fill="black"
              fillOpacity="0.7"
            />
            <path
              d="M143 136H122C119.239 136 117 138.239 117 141V147C117 149.761 119.239 152 122 152H143C145.761 152 148 149.761 148 147V141C148 138.239 145.761 136 143 136Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M143.984 157.747C143.995 157.83 144 157.914 144 158V167C144 173.075 139.075 178 133 178H132C125.925 178 121 173.075 121 167V158C121 157.914 121.005 157.83 121.016 157.747C121.005 157.665 121 157.583 121 157.5C121 155.567 123.91 154 127.5 154C129.51 154 131.308 154.491 132.5 155.263C133.692 154.491 135.49 154 137.5 154C141.09 154 144 155.567 144 157.5C144 157.583 143.995 157.665 143.984 157.747Z"
              fill="#FF4F6D"
            />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M120 130C120 134.418 125.373 138 132 138C138.627 138 144 134.418 144 130"
            fill="black"
            fillOpacity="0.16"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M92.1602 112.447C94.0067 108.649 98.1644 106 102.998 106C107.814 106 111.959 108.63 113.815 112.407C114.367 113.529 113.582 114.447 112.791 113.767C110.34 111.66 106.859 110.344 102.998 110.344C99.2572 110.344 95.8738 111.579 93.4375 113.572C92.5468 114.3 91.6201 113.558 92.1602 112.447Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M150.16 112.447C152.007 108.649 156.164 106 160.998 106C165.814 106 169.959 108.63 171.815 112.407C172.367 113.529 171.582 114.447 170.791 113.767C168.34 111.66 164.859 110.344 160.998 110.344C157.257 110.344 153.874 111.579 151.438 113.572C150.547 114.3 149.62 113.558 150.16 112.447Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M120.095 99.1246C120.099 99.1164 120.099 99.1164 120.095 99.1246V99.1246ZM95.2836 87.0051C92.9159 86.7391 90.4264 87.5024 88.8574 89.4389C88.2673 90.1669 87.3038 91.9186 87.3485 92.8556C87.3652 93.2117 87.5733 93.2313 88.4722 93.4457C90.1177 93.8379 92.9721 92.3318 94.827 92.4739C97.4089 92.6716 99.8735 93.8694 102.11 95.1527C105.948 97.3555 110.464 101.993 115.203 101.751C115.556 101.733 120.623 100.012 119.614 99.0285C119.297 98.5444 116.579 97.9004 116.112 97.667C113.94 96.583 111.745 95.2189 109.669 93.9486C105.141 91.1772 100.725 87.6107 95.2836 87.0051Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M144.03 99.1246C144.026 99.1164 144.026 99.1164 144.03 99.1246V99.1246ZM168.906 87.0051C171.274 86.7391 173.763 87.5024 175.332 89.4389C175.922 90.1669 176.886 91.9186 176.841 92.8556C176.824 93.2117 176.616 93.2313 175.717 93.4457C174.072 93.8379 171.217 92.3318 169.362 92.4739C166.78 92.6716 164.316 93.8694 162.08 95.1527C158.241 97.3555 153.725 101.993 148.987 101.751C148.634 101.733 143.567 100.012 144.576 99.0285C144.893 98.5444 147.61 97.9004 148.078 97.667C150.249 96.583 152.444 95.2189 154.52 93.9486C159.048 91.1772 163.465 87.6107 168.906 87.0051Z"
            fill="black"
            fillOpacity="0.6"
          />
          <mask
            id="mask3_1_572"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="264"
            height="280"
          >
            <path d="M264 0H0V280H264V0Z" fill="white" />
          </mask>
          <g mask="url(#mask3_1_572)">
            <mask
              id="mask4_1_572"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="58"
              y="18"
              width="148"
              height="258"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M191.506 99.3351C195.364 101.331 198 105.357 198 110V123C198 129.019 193.569 134.002 187.791 134.867C186.048 155.115 173.531 172.283 156 180.611V199H160C177.491 199 193.525 205.237 206 215.608V92C206 71.5655 197.717 53.0655 184.326 39.6741C170.935 26.2827 152.435 18 132 18C91.1309 18 58 51.1309 58 92V275.716C71.5692 273.776 82 262.106 82 248V202.423C88.9347 200.2 96.3272 199 104 199H108V180.611C96.7726 175.277 87.6015 166.318 82 155.246V93.266C91.1468 90.291 100.778 86.0171 110.342 80.4953C125.745 71.6024 138.431 60.9409 147.066 50.397C148.831 55.5951 151.175 60.801 154.11 65.8848C162.878 81.0705 175.224 92.2337 188 97.917V98.1659C188.4 98.2331 188.794 98.3201 189.18 98.4259C189.955 98.7493 190.73 99.0525 191.506 99.3351Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask4_1_572)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M191.506 99.3351C195.364 101.331 198 105.357 198 110V123C198 129.019 193.569 134.002 187.791 134.867C186.048 155.115 173.531 172.283 156 180.611V199H160C177.491 199 193.525 205.237 206 215.608V92C206 71.5655 197.717 53.0655 184.326 39.6741C170.935 26.2827 152.435 18 132 18C91.1309 18 58 51.1309 58 92V275.716C71.5692 273.776 82 262.106 82 248V202.423C88.9347 200.2 96.3272 199 104 199H108V180.611C96.7726 175.277 87.6015 166.318 82 155.246V93.266C91.1468 90.291 100.778 86.0171 110.342 80.4953C125.745 71.6024 138.431 60.9409 147.066 50.397C148.831 55.5951 151.175 60.801 154.11 65.8848C162.878 81.0705 175.224 92.2337 188 97.917V98.1659C188.4 98.2331 188.794 98.3201 189.18 98.4259C189.955 98.7493 190.73 99.0525 191.506 99.3351Z"
                fill="#944F23"
              />
              <path d="M322 18H58V298H322V18Z" fill="#D6B370" />
            </g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M191.506 99.3351C196.374 101.108 201.263 102.072 206 102.148V92C206 71.5655 197.717 53.0655 184.326 39.6741C197.717 53.0655 206 71.5655 206 92V215.608C193.525 205.237 177.491 199 160 199H156V180.611C173.531 172.283 186.048 155.115 187.791 134.867C193.569 134.002 198 129.019 198 123V110C198 105.357 195.364 101.331 191.506 99.3351ZM189.18 98.4259C188.794 98.3201 188.4 98.2331 188 98.1659V97.917C188.393 98.0919 188.786 98.2615 189.18 98.4259ZM82 155.246C87.6015 166.318 96.7726 175.277 108 180.611V199H104C96.3272 199 88.9347 200.2 82 202.423V155.246Z"
              fill="black"
              fillOpacity="0.24"
            />
          </g>
        </svg>
      );
    default:
      return (
        <svg viewBox="0 -3 264 280" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_1_2" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse">
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_1_2)">
            <path
              d="M156 180.611V199H160C199.765 199 232 231.235 232 271V280H32V271C32 231.235 64.2355 199 104 199H108V180.611C90.7626 172.422 78.3722 155.687 76.3051 135.881C70.4803 135.058 66 130.052 66 124V110C66 104.054 70.3246 99.1181 76 98.1659V92C76 61.0721 101.072 36 132 36C162.928 36 188 61.0721 188 92V98.1659C193.675 99.1181 198 104.054 198 110V124C198 130.052 193.52 135.058 187.695 135.881C185.628 155.687 173.237 172.422 156 180.611Z"
              fill="#D0C6AC"
            />
            <path d="M296 36H32V316H296V36Z" fill="#EDB98A" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M188 115V138C188 168.928 162.928 194 132 194C101.072 194 76 168.928 76 138V115V130C76 160.928 101.072 186 132 186C162.928 186 188 160.928 188 130V115Z"
              fill="black"
              fillOpacity="0.1"
            />
          </g>
          <mask
            id="mask1_1_2"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="183"
            width="200"
            height="97"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M108 183.071C90.0813 185.076 76.2798 190.552 76.0042 204.645C50.1464 215.568 32 241.165 32 270.999V280H232V270.999C232 241.165 213.854 215.568 187.996 204.645C187.72 190.552 173.919 185.076 156 183.071V202C156 215.255 145.255 226 132 226C118.745 226 108 215.255 108 202V183.071Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_1_2)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M108 183.071C90.0813 185.076 76.2798 190.552 76.0042 204.645C50.1464 215.568 32 241.165 32 270.999V280H232V270.999C232 241.165 213.854 215.568 187.996 204.645C187.72 190.552 173.919 185.076 156 183.071V202C156 215.255 145.255 226 132 226C118.745 226 108 215.255 108 202V183.071Z"
              fill="#B7C1DB"
            />
            <path d="M264 170H0V280H264V170Z" fill="#3C4F5C" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M102 231.739V280H95V228.15C97.2038 229.46 99.5468 230.661 102 231.739ZM169 228.15V268.5C169 270.433 167.433 272 165.5 272C163.567 272 162 270.433 162 268.5V231.739C164.453 230.661 166.796 229.46 169 228.15Z"
              fill="#F4F4F4"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M90.9601 182.724C75.9093 185.571 65.5 191.243 65.5 202.308C65.5 222.02 98.5377 238 132 238C165.462 238 198.5 222.02 198.5 202.308C198.5 191.243 188.091 185.571 173.04 182.724C182.125 186.074 188 191.706 188 201.077C188 221.469 160.179 238 132 238C103.821 238 76 221.469 76 201.077C76 191.706 81.8751 186.074 90.9601 182.724Z"
              fill="black"
              fillOpacity="0.16"
            />
          </g>
          <path
            d="M141 152H123C121.343 152 120 153.343 120 155C120 156.657 121.343 158 123 158H141C142.657 158 144 156.657 144 155C144 153.343 142.657 152 141 152Z"
            fill="black"
            fillOpacity="0.7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M120 130C120 134.418 125.373 138 132 138C138.627 138 144 134.418 144 130"
            fill="black"
            fillOpacity="0.16"
          />
          <path
            d="M106 126C113.732 126 120 119.732 120 112C120 104.268 113.732 98 106 98C98.268 98 92 104.268 92 112C92 119.732 98.268 126 106 126Z"
            fill="white"
          />
          <path
            d="M158 126C165.732 126 172 119.732 172 112C172 104.268 165.732 98 158 98C150.268 98 144 104.268 144 112C144 119.732 150.268 126 158 126Z"
            fill="white"
          />
          <path
            d="M106 118C109.314 118 112 115.314 112 112C112 108.686 109.314 106 106 106C102.686 106 100 108.686 100 112C100 115.314 102.686 118 106 118Z"
            fill="black"
            fillOpacity="0.7"
          />
          <path
            d="M158 118C161.314 118 164 115.314 164 112C164 108.686 161.314 106 158 106C154.686 106 152 108.686 152 112C152 115.314 154.686 118 158 118Z"
            fill="black"
            fillOpacity="0.7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M114.66 93.0903C109.662 93.4522 104.737 93.1757 99.7423 92.9684C95.9124 92.8098 92.0249 92.2868 88.3685 93.9801C87.6683 94.304 83.8383 96.2592 83.9274 97.3289C83.9984 98.1844 87.863 99.5204 88.5587 99.765C92.2274 101.055 95.7394 100.661 99.5125 100.434C104.14 100.157 108.748 100.361 113.374 100.221C116.489 100.128 121.29 99.6003 122.83 95.8233C123.294 94.6857 122.935 92.4099 122.47 91.1658C122.285 90.6702 121.75 90.4835 121.345 90.7691C119.895 91.7921 117.084 92.9151 114.66 93.0903Z"
            fill="black"
            fillOpacity="0.6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M149.341 93.0903C154.338 93.4522 159.263 93.1757 164.258 92.9684C168.088 92.8098 171.975 92.2868 175.632 93.9801C176.332 94.304 180.162 96.2592 180.073 97.3289C180.002 98.1844 176.137 99.5204 175.441 99.765C171.773 101.055 168.261 100.661 164.488 100.434C159.86 100.157 155.253 100.361 150.627 100.221C147.511 100.128 142.71 99.6003 141.17 95.8233C140.707 94.6857 141.065 92.4099 141.53 91.1658C141.715 90.6702 142.25 90.4835 142.655 90.7691C144.105 91.7921 146.916 92.9151 149.341 93.0903Z"
            fill="black"
            fillOpacity="0.6"
          />
          <mask
            id="mask2_1_2"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="264"
            height="280"
          >
            <path d="M264 0H0V280H264V0Z" fill="white" />
          </mask>
          <g mask="url(#mask2_1_2)">
            <mask
              id="mask3_1_2"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="72"
              y="98"
              width="121"
              height="120"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M113.18 149.737C115.363 148.105 128.407 147.479 130.758 146.089C131.492 145.655 132.061 145.216 132.5 144.78C132.939 145.216 133.509 145.655 134.242 146.089C136.593 147.479 149.637 148.105 151.82 149.737C154.03 151.391 155.644 155.185 155.467 158.151C155.255 161.71 151.361 170.203 141.672 171.181C139.558 168.828 136.237 167.31 132.5 167.31C128.763 167.31 125.442 168.828 123.328 171.181C113.639 170.203 109.745 161.71 109.533 158.151C109.357 155.185 110.97 151.391 113.18 149.737ZM151.142 166.906C151.143 166.906 151.145 166.905 151.146 166.905C151.144 166.905 151.143 166.906 151.142 166.906ZM113.845 166.901C113.849 166.903 113.857 166.906 113.862 166.908C113.857 166.906 113.851 166.903 113.845 166.901ZM192.863 127.985C192.474 122.03 191.278 116.152 190.234 110.286C189.953 108.707 188.424 98 187.735 98C187.502 107.109 186.702 116.08 185.67 125.139C185.361 127.848 185.038 130.556 184.825 133.274C184.654 135.47 184.96 138.122 184.428 140.246C183.749 142.952 180.348 145.478 177.703 146.411C171.103 148.737 165.598 139.108 159.961 136.291C152.643 132.635 140.064 131.764 132.582 136.53C124.936 131.764 112.357 132.635 105.039 136.291C99.4024 139.108 93.897 148.737 87.2972 146.411C84.6521 145.478 81.2504 142.952 80.5724 140.246C80.0403 138.122 80.3463 135.47 80.175 133.274C79.9624 130.556 79.6389 127.848 79.3302 125.139C78.2983 116.08 77.4975 107.109 77.2654 98C76.5762 98 75.0468 108.707 74.7659 110.286C73.7221 116.152 72.5258 122.03 72.1376 127.985C71.7385 134.105 72.2149 140.167 73.4696 146.163C74.0687 149.028 74.7685 151.876 75.5189 154.704C76.3527 157.847 75.199 163.966 75.5723 167.192C76.2788 173.296 79.1543 185.2 82.3833 190.451C83.9441 192.989 85.7735 194.574 87.8165 196.619C89.7826 198.588 90.6039 201.64 92.7261 203.737C96.682 207.645 102.446 209.971 108.366 210.543C113.677 215.05 122.506 218 132.5 218C142.495 218 151.323 215.05 156.635 210.543C162.554 209.971 168.318 207.645 172.274 203.737C174.396 201.64 175.217 198.588 177.184 196.619C179.226 194.574 181.056 192.989 182.617 190.451C185.846 185.2 188.721 173.296 189.428 167.192C189.801 163.966 188.647 157.847 189.481 154.704C190.232 151.876 190.931 149.028 191.531 146.163C192.785 140.167 193.261 134.105 192.863 127.985Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask3_1_2)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M113.18 149.737C115.363 148.105 128.407 147.479 130.758 146.089C131.492 145.655 132.061 145.216 132.5 144.78C132.939 145.216 133.509 145.655 134.242 146.089C136.593 147.479 149.637 148.105 151.82 149.737C154.03 151.391 155.644 155.185 155.467 158.151C155.255 161.71 151.361 170.203 141.672 171.181C139.558 168.828 136.237 167.31 132.5 167.31C128.763 167.31 125.442 168.828 123.328 171.181C113.639 170.203 109.745 161.71 109.533 158.151C109.357 155.185 110.97 151.391 113.18 149.737ZM151.142 166.906C151.143 166.906 151.145 166.905 151.146 166.905C151.144 166.905 151.143 166.906 151.142 166.906ZM113.845 166.901C113.849 166.903 113.857 166.906 113.862 166.908C113.857 166.906 113.851 166.903 113.845 166.901ZM192.863 127.985C192.474 122.03 191.278 116.152 190.234 110.286C189.953 108.707 188.424 98 187.735 98C187.502 107.109 186.702 116.08 185.67 125.139C185.361 127.848 185.038 130.556 184.825 133.274C184.654 135.47 184.96 138.122 184.428 140.246C183.749 142.952 180.348 145.478 177.703 146.411C171.103 148.737 165.598 139.108 159.961 136.291C152.643 132.635 140.064 131.764 132.582 136.53C124.936 131.764 112.357 132.635 105.039 136.291C99.4024 139.108 93.897 148.737 87.2972 146.411C84.6521 145.478 81.2504 142.952 80.5724 140.246C80.0403 138.122 80.3463 135.47 80.175 133.274C79.9624 130.556 79.6389 127.848 79.3302 125.139C78.2983 116.08 77.4975 107.109 77.2654 98C76.5762 98 75.0468 108.707 74.7659 110.286C73.7221 116.152 72.5258 122.03 72.1376 127.985C71.7385 134.105 72.2149 140.167 73.4696 146.163C74.0687 149.028 74.7685 151.876 75.5189 154.704C76.3527 157.847 75.199 163.966 75.5723 167.192C76.2788 173.296 79.1543 185.2 82.3833 190.451C83.9441 192.989 85.7735 194.574 87.8165 196.619C89.7826 198.588 90.6039 201.64 92.7261 203.737C96.682 207.645 102.446 209.971 108.366 210.543C113.677 215.05 122.506 218 132.5 218C142.495 218 151.323 215.05 156.635 210.543C162.554 209.971 168.318 207.645 172.274 203.737C174.396 201.64 175.217 198.588 177.184 196.619C179.226 194.574 181.056 192.989 182.617 190.451C185.846 185.2 188.721 173.296 189.428 167.192C189.801 163.966 188.647 157.847 189.481 154.704C190.232 151.876 190.931 149.028 191.531 146.163C192.785 140.167 193.261 134.105 192.863 127.985Z"
                fill="#5E7AA9"
              />
              <path d="M280 72H16V316H280V72Z" fill="#A55728" />
            </g>
            <mask
              id="mask4_1_2"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="73"
              y="26"
              width="118"
              height="73"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M166.309 35.0061C146.121 23.3065 126.129 25.222 111.037 29.03C95.9448 32.838 87.0168 43.6513 79.3567 59.6481C75.5956 67.5029 73.366 76.7915 73.0231 85.4814C72.8884 88.8933 73.3484 92.4152 74.2677 95.7004C74.6049 96.9062 76.4232 101.087 76.9225 97.7088C77.0885 96.5843 76.4804 95.0328 76.4216 93.8376C76.3444 92.2694 76.4273 90.6808 76.5342 89.1149C76.7341 86.1874 77.256 83.3154 78.1847 80.5247C79.5119 76.5367 81.2014 72.2129 83.7874 68.8481C90.1884 60.5206 101.269 60.0459 110.066 55.4636C109.303 56.8687 106.36 59.1433 107.379 60.7269C108.084 61.8207 110.749 61.4891 112.022 61.454C115.371 61.3624 118.735 60.7797 122.043 60.307C127.256 59.5618 132.141 58.0518 137.047 56.2181C141.063 54.7164 145.65 53.3257 148.669 50.1405C153.54 55.1881 159.81 59.9346 166.07 63.1429C171.688 66.0222 180.749 67.4611 184.183 73.3007C188.248 80.2148 186.378 88.7074 187.619 96.2008C188.091 99.0504 189.164 98.9866 189.751 96.4378C190.748 92.1083 191.219 87.6102 190.902 83.1593C190.184 73.1115 186.497 46.7057 166.309 35.0061Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask4_1_2)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M166.309 35.0061C146.121 23.3065 126.129 25.222 111.037 29.03C95.9448 32.838 87.0168 43.6513 79.3567 59.6481C75.5956 67.5029 73.366 76.7915 73.0231 85.4814C72.8884 88.8933 73.3484 92.4152 74.2677 95.7004C74.6049 96.9062 76.4232 101.087 76.9225 97.7088C77.0885 96.5843 76.4804 95.0328 76.4216 93.8376C76.3444 92.2694 76.4273 90.6808 76.5342 89.1149C76.7341 86.1874 77.256 83.3154 78.1847 80.5247C79.5119 76.5367 81.2014 72.2129 83.7874 68.8481C90.1884 60.5206 101.269 60.0459 110.066 55.4636C109.303 56.8687 106.36 59.1433 107.379 60.7269C108.084 61.8207 110.749 61.4891 112.022 61.454C115.371 61.3624 118.735 60.7797 122.043 60.307C127.256 59.5618 132.141 58.0518 137.047 56.2181C141.063 54.7164 145.65 53.3257 148.669 50.1405C153.54 55.1881 159.81 59.9346 166.07 63.1429C171.688 66.0222 180.749 67.4611 184.183 73.3007C188.248 80.2148 186.378 88.7074 187.619 96.2008C188.091 99.0504 189.164 98.9866 189.751 96.4378C190.748 92.1083 191.219 87.6102 190.902 83.1593C190.184 73.1115 186.497 46.7057 166.309 35.0061Z"
                fill="#28354B"
              />
              <path d="M263 0H-1V280H263V0Z" fill="#724133" />
            </g>
          </g>
        </svg>
      );
  }
};

export default Avatar;
